import state from './state.js'
import mutations from './mutation.js'
import actions from './action.js'
import getters from './getters.js'

export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}

//to test do this
// console.log("new Store:", this.$store.state.profile.sampleState);
// this.$store.dispatch('profile/setSampleState',"Aron is now Awesome");
//    console.log("new Store:", this.$store.state.profile.sampleState);

